import * as React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Button, Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import { ApiPasswordRequest, ServerResponse } from '../../api';
import ErrorBox from '../../components/errorBox/ErrorBox';
import Footer from '../../components/footer/Footer';
import HeaderLoggedOut from '../../components/headerLoggedOut/HeaderLoggedOut';
import './ForgotPassword.css';

interface ForgotPasswordState {
    serverResponse: ServerResponse | undefined;
    email: string;
}

export default class ForgotPassword extends React.PureComponent<any, ForgotPasswordState> {
    constructor(props: any) {
        super(props);
        this.state = {
            email: '',
            serverResponse: undefined,
        };
    }

    public render() {
        if (this.state.serverResponse && this.state.serverResponse.OK) {
            return <Redirect to="/forgotPasswordResult" />;
        }

        return (
            <>
                <HeaderLoggedOut />
                <Container id="forgotPasswordView" className="text-center">
                    <Row>
                        <Col>
                            <h3>{TR.forgotPassword_forgot_password}</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className="offset-md-3">
                            {TR.forgotPassword_forgot_help}
                            <br />
                            <Form className="mt-4">
                                <ErrorBox serverResponse={this.state.serverResponse} />
                                <FormGroup>
                                    <Label>{TR.forgotPassword_email}</Label>
                                    <Input type="email" id="email" onChange={this.inputHandler} />
                                </FormGroup>
                                <Button className="mt-3" onClick={this.passwordRequest}>
                                    {TR.forgotPassword_send_link}
                                </Button>
                                <br />
                                <br />
                                <Link to="/">&lt; {TR.forgotPassword_back_to_login}</Link>
                            </Form>
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </>
        );
    }

    private inputHandler = (e: any) => {
        this.setState({ serverResponse: undefined });
        const newstate = {};
        // @ts-ignore
        newstate[e.target.id] = e.target.value;
        this.setState(newstate);
    };

    private passwordRequest = () => {
        ApiPasswordRequest({ Email: this.state.email }, (sr: ServerResponse) => {
            this.setState({ serverResponse: sr });
        });
    };
}



// WEBPACK FOOTER //
// ./src/views/forgotPassword/ForgotPassword.tsx